export interface IStats {
  title: string;
  value?: string | number;
  show?: boolean;
  isPrice?: boolean;
  hasInfo?: boolean;
  infoAction?: () => void;
}

const StatsGrid = ({stats}: {stats: IStats[]}) => {
  const visibleStats = stats.filter(stat => stat.show !== false);

  const formattedStats = visibleStats.map(stat => ({
    ...stat,
    formattedValue:
      typeof stat.value === 'number' ? stat.value.toLocaleString() : stat.value,
  }));

  return (
    <div className="flex flex-col px-2">
      {formattedStats.map((stat, index) => (
        <div key={index} className="flex justify-between py-3 border-b-[1px]">
          <div className="flex items-center justify-center gap-1">
            <span className="text-sm text-gray-700">{stat.title}</span>

            {stat.hasInfo && (
              <i
                className="text-lg icon-namereport text-farm-shop-500"
                onClick={stat.infoAction}
              />
            )}
          </div>

          <div className="flex items-center justify-center gap-1 font-medium">
            <span>{stat.formattedValue}</span>

            {stat.isPrice && Boolean(stat.value) && (
              <span className="text-sm">تومان</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsGrid;
